import { jsx as c } from "@emotion/react/jsx-runtime";
import d from "@emotion/styled/base";
import { useMemo as G } from "react";
import { useListContext as A } from "./ListContext.js";
function s() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const u = /* @__PURE__ */ d("div", process.env.NODE_ENV === "production" ? {
  target: "ejk7kq60"
} : {
  target: "ejk7kq60",
  label: "FlexDiv"
})(process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "82a6rk",
  styles: "flex:1/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvRGF0YURpc3BsYXkvTGlzdC9TZWxlY3RCYXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU8wQiIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9wYXJ0b28tdWkvcGFydG9vLXVpL3BhY2thZ2VzL3VpL3NyYy9jb21wb25lbnRzL0RhdGFEaXNwbGF5L0xpc3QvU2VsZWN0QmFyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgdXNlTWVtbyB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyB1c2VMaXN0Q29udGV4dCB9IGZyb20gJy4vTGlzdENvbnRleHQnO1xuXG5jb25zdCBGbGV4RGl2ID0gc3R5bGVkLmRpdmBcbiAgICBmbGV4OiAxO1xuYDtcblxudHlwZSBTZWxlY3RCYXJQcm9wczxUPiA9IHtcbiAgICBjaGlsZHJlbjogKHA6IHsgc2VsZWN0ZWRJdGVtczogVFtdOyB1bnNlbGVjdEFsbDogKCkgPT4gdm9pZCB9KSA9PiBSZWFjdE5vZGU7XG4gICAgZGF0YTogVFtdO1xuICAgIC8qKlxuICAgICAqIFRoZSBpZEtleSBvZiBlYWNoIGRhdGEgZW50cnlcbiAgICAgKiAqL1xuICAgIGlkS2V5OiBrZXlvZiBUO1xufTtcblxuZXhwb3J0IGZ1bmN0aW9uIFNlbGVjdEJhcjxUPih7IGNoaWxkcmVuLCBkYXRhLCBpZEtleSB9OiBSZWFkb25seTxTZWxlY3RCYXJQcm9wczxUPj4pIHtcbiAgICBjb25zdCB7IHNlbGVjdGVkUm93SWRzLCB1bnNlbGVjdEFsbCB9ID0gdXNlTGlzdENvbnRleHQoKTtcblxuICAgIGNvbnN0IHNlbGVjdGVkSXRlbXMgPSB1c2VNZW1vKFxuICAgICAgICAoKSA9PiBkYXRhLmZpbHRlcihpdGVtID0+IHNlbGVjdGVkUm93SWRzW2l0ZW1baWRLZXldIGFzIHN0cmluZ10pLFxuICAgICAgICBbZGF0YSwgaWRLZXksIHNlbGVjdGVkUm93SWRzXSxcbiAgICApO1xuXG4gICAgaWYgKHNlbGVjdGVkSXRlbXMubGVuZ3RoID09PSAwKSB7XG4gICAgICAgIHJldHVybiBudWxsO1xuICAgIH1cblxuICAgIHJldHVybiAoXG4gICAgICAgIDxGbGV4RGl2PlxuICAgICAgICAgICAge2NoaWxkcmVuKHtcbiAgICAgICAgICAgICAgICBzZWxlY3RlZEl0ZW1zLFxuICAgICAgICAgICAgICAgIHVuc2VsZWN0QWxsLFxuICAgICAgICAgICAgfSl9XG4gICAgICAgIDwvRmxleERpdj5cbiAgICApO1xufVxuIl19 */",
  toString: s
});
function x({
  children: t,
  data: I,
  idKey: l
}) {
  const {
    selectedRowIds: b,
    unselectAll: e
  } = A(), g = G(() => I.filter((C) => b[C[l]]), [I, l, b]);
  return g.length === 0 ? null : /* @__PURE__ */ c(u, { children: t({
    selectedItems: g,
    unselectAll: e
  }) });
}
export {
  x as SelectBar
};
